// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  envName: 'production',
  urls:
  {
    source: 'https://teachers.lingueo.com',
    url: 'https://teachers.lingueo.com',
    module: 'teacher',
    default_role: 'teacher',
    gtagID: 'UA-3750617-17',
    crispID: '60473231-0966-4e89-be44-dfdbf928aa48',
    sentryDsn: 'https://c6d9d8d0becc4e3db157a3b60bc493ad@o315478.ingest.us.sentry.io/1796050',
    languages: ['en'],
    defaultLanguage: 'en',
    teacher: 'https://teachers.lingueo.com',
    lingueopro: 'https://app.lingueo.com',
    lilate: 'https://app.lilate.org',
    exam: 'https://exam.lilate.org',
    elate: 'https://flashlevel.lilate.org/',
  },
  backofficeUrl: 'https://manage.lingueo.com',
  base_server: 'https://api.recurring.lingueo.fr',
  server: 'https://api.recurring.lingueo.fr/api/v1/',
  ws_server: 'wss://api.recurring.lingueo.fr/ws/',
  auth: 'https://api.recurring.lingueo.fr/api/v1/auth/',
  me: 'https://api.recurring.lingueo.fr/api/v1/me/',
  media: 'https://api.recurring.lingueo.fr/media/',
  static: 'https://api.recurring.lingueo.fr/static/',
  application_id: 'MX6xlCV4G5at4r31biAN9UG7VyrHggCrUHigyBY1TnrXhqak1xZWLSHETIoAiG9SYDZQqkwFRuUgM39zedn34Kh0itVCX3bfdnJFTjwH0ThUOdbjZqjl6709gXskESpD',
  client_id: 'fHJJ2cPFjzgRkb6ei3mFCLuC6KaLSuySWJbN1abz',
  test: 'fake-prod',
  default_teacher_site: 'https://api.recurring.lingueo.fr/api/v1/sites/2/',
  default_admin_site: 'https://api.recurring.lingueo.fr/api/v1/sites/1/',
  default_student_site: 'https://api.recurring.lingueo.fr/api/v1/sites/4/',
  default_event_rule: 'https://api.recurring.lingueo.fr/api/v1/rules/3/',
  documents: '/api/v1/documents/',
  calendar_export: '/api/v1/calendar/export/',
  maxFileSize: 262144000,
  fileSizeAlert: 'Merci de bien vouloir télécharger un document de moins de 26 mo',
  //aiServer: 'https://d8462bb2-5405-4a87-ad73-f65ddcef80d5.app.gra.ai.cloud.ovh.net/',
  aiServer: 'https://api.elate.lingueo.com/',
};
